// extracted by mini-css-extract-plugin
module.exports = {"Speaker":"Speaker_Summary_Speaker__eafEI","Image":"Speaker_Summary_Image__6Um3y","Company":"Speaker_Summary_Company__wD_Iv","Preview":"Speaker_Summary_Preview__ePn8I"};